import { createReducer } from '@reduxjs/toolkit'
import * as actions from './actions'

export interface CartState {
  cartNFT: any
  addToCartAnimation: {
    x: number
    y: number
    action: boolean
    url: string
    type: 'image' | 'video'
  }
}

const initialState: CartState = {
  cartNFT: [],
  addToCartAnimation: {
    x: 0,
    y: 0,
    action: false,
    url: '',
    type: 'image',
  },
}

export default createReducer<CartState>(initialState, (builder) =>
  builder
    .addCase(actions.setAddToCart, (state, { payload }) => {
      state.cartNFT = payload
    })
    .addCase(actions.setAddToCartAnimation, (state, { payload }) => {
      state.addToCartAnimation = payload
    }),
)
